import moment from 'moment'
import React from 'react'
import Parser from 'html-react-parser';

const step_four = ({ Data, nextStep, prevStep }) => {
    const skill = Data && Data.KEYWORDS && Data.KEYWORDS.map((d, i) => {
        return d.SKILL
    })
    return (
        <React.Fragment>


            {Data &&
                < table className="table table-striped mb-0">
                    <tbody>
                        <tr>
                            <td>Job Title</td>
                            <td>{Data.JOB_TITLE}</td>
                        </tr>
                        {/* <tr>
                        <td>Employment Type</td>
                        <td>{Data.EMPLOYMENT_TYPE_ID}</td>
                    </tr> */}
                        <tr>
                            <td>Work Location</td>
                            <td>{Data.IS_FIELD_JOB ? (Data.ADDRESS) + 'Field Job' : Data.IS_WORK_FROM_HOME_DURING_COVID === 'Y' && Data.TYPE_OF_WORK_FROM_HOME === 'WFHDC' ? (Data.ADDRESS) + 'Hybrid' : Data.IS_WORK_FROM_HOME_DURING_COVID === 'Y' && Data.TYPE_OF_WORK_FROM_HOME === 'PRJ' ? 'Remote Job' : Data.ADDRESS}</td>
                        </tr>
                        <tr>
                            <td>Key Skills</td>
                            <td>
                                {skill.toString().replace(/,/g, ', ')}
                            </td>
                        </tr>
                        <tr>
                            <td>Work Experience (Years)</td>
                            <td>{`${Data.WORK_EXP_MIN}-${Data.WORK_EXP_MAX} year`}</td>
                        </tr>
                        <tr>
                            <td>Job Description</td>
                            <td>{Data.JOB_DETAILS ? Parser(Data.JOB_DETAILS) : "NA"}</td>
                        </tr>
                        <tr>
                            <td>Annual Salary Range</td>
                            <td>{`${Data.CTC_MIN / 100000}-${Data.CTC_MAX / 100000} LPA`}</td>
                        </tr>
                        <tr>
                            <td>Hide salary details from candidates</td>
                            <td>{Data.IS_HIDE_SALARY_FROM_CANDIDATE}</td>
                        </tr>

                        <tr>
                            <td>Location</td>
                            <td>
                                {Data && Data.CITY_ID && Data.CITY_ID.map((d, i) => {
                                    return d.CITY
                                }).join(', ')}
                            </td>
                        </tr>


                        <tr>
                            <td>Number Of Vacancies </td>
                            <td>{Data.NO_OF_VACANCIES}</td>
                        </tr>
                        <tr>
                            <td>Minimum Qualification</td>
                            <td>
                                {Data && Data.QUALIFICATION_ID && Data.QUALIFICATION_ID.map((d, i) => {
                                    return d.QUALIFICATION_NAME
                                }).join(', ')}
                            </td>
                        </tr>
                        <tr>
                            <td>Degree</td>
                            <td>
                                {Data && Data.EDUCATION_QUALIFICATION_ID && Data.EDUCATION_QUALIFICATION_ID.map((d, i) => {
                                    return d.COURSE_STREAM
                                }).join(', ')}
                            </td>
                        </tr>
                        <tr>
                            <td>Specialization</td>
                            <td>
                                {Data && Data.COURSE_SPECIALIZATION && Data.COURSE_SPECIALIZATION.map((d, i) => {
                                    return d.SPECIALIZATION
                                }).join(', ')}
                            </td>
                        </tr>
                        {Data.IS_INCLUDE_WALK_IN === 'Y' &&
                            <React.Fragment>
                                <tr>
                                    <td>Include walk-in distance</td>
                                    <td>{Data.IS_INCLUDE_WALK_IN}</td>
                                </tr>
                                <tr>
                                    <td>Walk-In Start Date</td>
                                    <td>{moment(Data.WALK_IN_START_DATE).format('DD-MMM-YYYY')}</td>
                                </tr>
                                <tr>
                                    <td>Walk-In Start Timing</td>
                                    <td>{Data.WALK_IN_START_TIME == "null" ? "NA" : Data.WALK_IN_START_TIME}</td>
                                </tr>
                                <tr>
                                    <td>Walk-In End Timing</td>
                                    <td>{Data.WALK_IN_END_TIME == "null" ? 'NA' : Data.WALK_IN_END_TIME}</td>
                                </tr>
                                <tr>
                                    <td>Duration (Days)</td>
                                    <td>{Data.DURATION == "null" ? "NA" : Data.DURATION}</td>
                                </tr>
                                <tr>
                                    <td>Contact Person</td>
                                    <td>{Data.CONTACT_PERSON == "null" ? "NA" : Data.CONTACT_PERSON}</td>
                                </tr>
                                <tr>
                                    <td>Contact Number</td>
                                    <td>{Data.MOBILE_NUMBER == "null" ? "NA" : Data.MOBILE_NUMBER}</td>
                                </tr>
                                <tr>
                                    <td>Venue</td>
                                    <td>{Data.VENUE}</td>
                                </tr>
                            </React.Fragment>

                        }
                        {/* <tr>
                            <td>Google Map URL</td>
                            <td>Google Map URL</td>
                        </tr> */}

                        <tr>
                            <td>Company Name</td>
                            <td>{Data.COMPANY_NAME == "null" ? "NA" : Data.COMPANY_NAME}</td>
                        </tr>
                        {/* <tr>
                            <td>Client Name </td>
                            <td>{Data.CLIENT_NAME == "null" ? "NA" : Data.CLIENT_NAME}</td>
                        </tr>
                        <tr>
                            <td>Client Details Section</td>
                            <td>{Data.CLIENT_DETAILS == "null" ? "NA" : Data.CLIENT_DETAILS}</td>
                        </tr>
                        <tr>
                            <td>Client Company Address</td>
                            <td>{Data.ADDRESS == "null" ? "NA" : Data.ADDRESS}</td>
                        </tr> */}

                    </tbody>
                </table>}

            <div className='row'>
                <div class="col-12 text-right pb-3 pt-3">
                    <button type='button' className='rg-btn theme-btn mr-2 py-1 px-2' style={{ border: 'none', outline: 'none', borderRadius: "4px" }} onClick={() => prevStep()}>Previous</button>
                    <button type='button' className='rg-btn rg-active theme-btn py-1 px-3' style={{ border: 'none', outline: 'none', borderRadius: "4px" }} onClick={() => nextStep()} >Continue</button>
                </div>
            </div>
        </React.Fragment >
    )
}

export default step_four